import script from "./DatabaseManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseManager.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseManager.vue?vue&type=style&index=0&id=743de6c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743de6c5"]])

export default __exports__